import { Dispatch, MutableRefObject, SetStateAction, useRef, useState } from 'react';
import { commentService } from '@tap/data-providers';
import Editor from 'react-markdown-editor-lite';

type UseCommentProps = {
    documentKeys?: string[],
    actionCode?: string,
    inputMessage?: string,
    commentId?: number,
}

export type UseCommentState = {
    message: string,
    setMessage: Dispatch<SetStateAction<string>>,
    addCommentShow: boolean,
    editorRef: MutableRefObject<Editor | null>,
    addComment: () => Promise<any>,
    editComment: () => Promise<any>,
    clearComment: () => void,
    focus: () => void,
    showAddComment: () => void,
    hideAddComment: () => void,
}

export const useComment = ({
    documentKeys,
    commentId,
    inputMessage,
    actionCode,
}: UseCommentProps): UseCommentState => {

    const [message, setMessage] = useState(inputMessage ?? '');
    const [addCommentShow, setAddCommentShow] = useState(false);
    const editorRef = useRef<Editor>(null);


    const addComment = () => {
        if (message.length === 0 || !documentKeys) {
            return Promise.resolve();
        }
        return commentService.createCommentList(documentKeys, { message, actionCode })
            .then((res) => {
                clearComment();
                return res;
            });
    };

    const editComment = () => {
        if (message.length === 0 || typeof commentId !== 'number') {
            return Promise.resolve();
        }
        return commentService.editComment(commentId, { message })
            .then((res) => {
                clearComment();
                return res;
            });
    };

    const clearComment = () => {
        setMessage('');
    };


    const focus = () => {
        if (!editorRef.current) return;

        editorRef.current.nodeMdText.current.focus();
    }

    const showAddComment = () => {
        setAddCommentShow(true);
        setTimeout(() => focus(), 100); // Wait while editor will be visible to scroll on correct height.
    }

    const hideAddComment = () => {
        setAddCommentShow(false);
    }

    return {
        message,
        setMessage,
        editorRef,
        addComment,
        editComment,
        clearComment,
        addCommentShow,
        showAddComment,
        hideAddComment,
        focus,
    };
}